import {
  Companies,
  Configuration,
  FeatureFlag,
  Feedbacks,
  Offer,
  Offers,
  Product,
  Products,
  Queues,
  Retailer,
  Retailers,
  Snap,
  Snaps,
  Transactions,
} from 'containers';
import {
  DataPage,
  Page403,
  Page404,
} from 'components';

import { Links } from 'links';

const privateRoutes = (isAdmin: boolean) => [{
  path: '/',
  element: DataPage,
}, {
  path: Links.Snaps,
  element: Snaps,
}, {
  path: `${Links.Snaps}/:snapId`,
  element: Snap,
}, {
  path: Links.Offers,
  element: Offers,
}, {
  path: `${Links.Offers}/:offerId`,
  element: Offer,
}, {
  path: Links.Products,
  element: Products,
}, {
  path: `${Links.Products}/:productId`,
  element: Product,
}, {
  path: Links.Retailers,
  element: Retailers,
}, {
  path: `${Links.Retailers}/:retailerId`,
  element: Retailer,
}, {
  path: Links.NoAccess,
  element: Page403,
}, {
  path: Links.NotFound,
  element: Page404,
}, {
  path: Links.Companies,
  element: Companies,
}, {
  path: Links.Queues,
  element: Queues,
}, {
  path: Links.Transactions,
  element: () => <Transactions />,
},
...(isAdmin
  ? [{
    path: Links.Feedbacks,
    element: Feedbacks,
  }, {
    path: Links.FeatureFlag,
    element: () => <FeatureFlag />,
  }, {
    path: Links.Configuration,
    element: () => <Configuration />,
  }]
  : [])];

export { privateRoutes };
